import { Row, Steps } from "antd";
import React from "react";
import "./StepFlowComponent.scss";


import { IStepFlowComponentProps } from "./StepFlowInterfaces.types";

const { Step } = Steps;

function StepFlowComponent(props: IStepFlowComponentProps) {
  return (
    <Row className="StepFlow" style={{marginTop:'5px'}}>
      <Steps size="small" current={props.current ? props.current : 0 } className={'site-navigation-steps'}>
        <Step title={props.title} />
        <Step />
        <Step />
        <Step />
      </Steps>
    </Row>
  );
}


export default StepFlowComponent;
